export default __webpack_public_path__ + "static/media/copy.b6abd175.png";